window.sfDocumentReady(['route-integration-index'], () => {
  (($) => {
    // Softly truncating since we don't wanna mess with too strict
    // security for current state of our system (admin access only anyway)
    $('input.input--truncated').each((_, input) => {
      const value = $(input).attr('data-value')
      const valueLength = value.length
      const hiddenLength = Math.round(valueLength / 2)
      let maskPlaceholder = value.slice(0, -hiddenLength).padEnd(valueLength, '*')
      const maskInput = $(input).clone()
        .val(maskPlaceholder)
        .attr('data-value', '')
        .on('focus', () => maskPlaceholder && maskInput.val(''))
        .on('focusout', () => maskPlaceholder && maskInput.val(maskPlaceholder))
        .on('change', () => {
          maskPlaceholder = '' // Since the value changed, remove the initial value
          $(input).val(maskInput.val())
        })
        .attr('name', '')
        .attr('id', '')

      $(input).attr('type', 'hidden')
        .val(value)
        .attr('data-value', '')
        .after(maskInput)
    })

    $('.alert-danger').each(function () {
      $(this).html(
        $(this).text().replace(
          /Invalid settings for (\w+)/,
          `Invalid settings for <a href='#integrations_$1_settings'>$1</a>`
        )
      )
    })
  })(jQuery);
});
